<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { Event } from '@/api'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.ForeignKey({
              service: Event,
              label: 'Wydarzenia',
              modelPath: [this, 'form', 'events'],
              multiple: true,
              sortable: true,
              labelField: 'title_pl',
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
